import {useUserStore} from '~/store/userStore.js'
import {useLastVisitedProducts} from '~/store/lastVisitedProducts.js'
import {authHeaders} from '~/composables/apiAuth.js'

export const useStartupData = async () => {
    const config = useRuntimeConfig()
    const userStore = useUserStore()
    const lastVisitedProducts = useLastVisitedProducts()
    const locale = config.public.locale
    const startupKey = `startup:${locale}`
    const isLocalLike = ['local', 'dev'].includes(String(config.public.APP_ENV)) || import.meta.dev

    const headers = authHeaders({
        accept: 'application/json',
        referer: config.public.baseURL,
        lastVisitedProducts: JSON.stringify(lastVisitedProducts.products),
        'Accept-Language': locale,
    })

    const liveStartupFetch = {
        baseURL: config.public.API_URL,
        headers,
        timeout: 60000,
        retry: 1,
        retryDelay: 250,
    }

    // Cached public dump has no user. Live fetch is required whenever we have a
    // token, otherwise isAdmin can never become true (chicken-and-egg).
    if (userStore.isAuthenticated || userStore.isAdmin || isLocalLike) {
        return useFetch('startup', {
            ...liveStartupFetch,
            key: startupKey,
        })
    }

    return useAsyncData(startupKey, async () => {
        try {
            return await $fetch(`/api/internal/startup/${locale}`)
        } catch {
            return $fetch('startup', liveStartupFetch)
        }
    }, {
        getCachedData(key) {
            if (isLocalLike) {
                return undefined
            }

            return useNuxtApp().payload.data[key] ?? useNuxtApp().static.data[key]
        },
    })
}
